import css from 'styled-jsx/css';
import { isRTL, gradient } from 'common/styling/theme';

const staticStyles = css`
  @import 'src/common/styling/_mixins-scss/screen-size';
  @import 'src/common/styling/_mixins-scss/rem';

  .InvestStrategies {
    :global(.Collapsible) {
      margin-bottom: 20px;
      background: #ffffff;
    }

    :global(.NoItemsPanel) {
      background: #ffffff;
    }

    :global(.Collapsible__header) {
      box-shadow: none;
      padding: rem(25px 20px);
      position: relative;
      margin-bottom: 0;

      @include respond-to(sm) {
        background: #ffffff;
        border-radius: 3px;
      }
    }

    :global(.Collapsible__content) {
      :global(.Calendar) {
        display: flex;
        justify-content: flex-end;
        padding-top: 10px;
        padding-right: 30px;
      }

      :global(.Calendar) {
        @include respond-to(sm) {
          padding: 25px 15px 10px 15px;

          :global(.Calendar__data-info) {
            width: 100%;
            margin-bottom: 0;
          }
        }
      }
    }

    :global(.Collapsible__caption) {
      line-height: 32px;
      font-size: 26px;
      font-weight: 300;

      @include respond-to(sm) {
        font-size: 20px;
        line-height: 24px;
      }
    }

    :global(.Collapsible__arrow) {
      position: absolute;
      right: ${isRTL ? 'auto' : '30px'};
      left: ${isRTL ? '30px' : 'auto'};
      top: 50%;
    }

    :global(.Collapsible__arrow-right) {
      transform: ${isRTL
        ? 'translateY(-50%) rotate(135deg) !important'
        : ' translateY(-50%) rotate(-45deg) !important'};
    }

    :global(.Collapsible__arrow-down) {
      top: 40%;
      transform: rotate(45deg) translateY(-50%) !important;
    }

    :global(.NoItemsPanel) {
      height: auto;
    }
  }
`;

const getDynamicStyles = ({ colors }) => {
  return css`
    @import 'src/common/styling/_mixins-scss/screen-size';
    @import 'src/common/styling/_mixins-scss/rem';

    .InvestStrategies {
      &__tabs {
        padding: rem(5px 18px 25px);
        background: #ffffff;
        @include respond-to(sm) {
          width: 100%;
        }
      }

      &__tab {
        font-size: 20px;
        line-height: 23px;
        margin-right: ${isRTL ? '0' : '35px'};
        margin-left: ${isRTL ? '35px' : '0'};
        padding-bottom: 15px;
        cursor: pointer;
        border-bottom: 3px solid transparent;

        &:last-child {
          margin-right: 0;
        }

        &.active {
          color: ${colors.primary.hex};
          border-bottom-color: ${colors.primary.hex};
        }

        @include respond-to(sm) {
          font-size: 15px;
          line-height: normal;
          padding-bottom: 5px;
          border-bottom-width: 2px;
          margin-right: ${isRTL ? '0' : '15px'};
          margin-left: ${isRTL ? '15px' : '0'};
        }
      }

      :global(.Collapsible) {
        margin: 0;
        :global(.ReactTable) {
          :global(.rt-tfoot) {
            position: relative;

            &:after {
              content: '';
              position: absolute;
              top: -2px;
              left: 0;
              width: 100%;
              height: 2px;
              background: ${gradient(90, [colors.gradientStart.rgb, 1], 0, [colors.gradientEnd.rgb, 1], 100)};
            }
          }
        }
      }

      :global(.PaginationTable__pagination) {
        padding: rem(0 18px);
      }
    }
  `;
};

export { staticStyles, getDynamicStyles };
